import Vue from 'vue'
import Vuex from 'vuex'
import robots from "./js/robot"

import * as authApi from '@/utils/auth'
import IndexedDBService from '@/utils/db';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: authApi.getToken(),
        user: authApi.getUser(),
        id: 0,
        sessionId: '',
        robotId: '',
        messageStorage: {},
        robotSessionMap: {},
        papers: [],
        robots: robots,
        timer: null,
        foldHistory: false,
        foldRobot: false,
        theme: 'light',
        isMobile: false,
        deviceHeight: 0,
        isKeyboardOpen: false,
        lastLevelType: 'h',
        level: '',
        conversations: [],
        activeConversation: null,
        dbInitialized: false
    },
    mutations: {
        setToken(state, token) {
            state.token = token
            authApi.setToken(token)
            authApi.removeZsToken()
        },
        removeToken(state) {
            state.token = ""
            authApi.removeToken()
            authApi.removeZsToken()
        },
        setUser(state, user) {
            Object.keys(user).forEach(key => {
              if (state.user[key] !== user[key]) {
                state.user[key] = user[key];
              }
            });
            authApi.setUser(state.user);
        },
        removeUser(state) {
            state.user = {}
            authApi.removeUser()
        },
        setSessionId(state, sessionId) {
            state.sessionId = sessionId
        },
        setRobotId(state, robotId) {
            state.robotId = robotId
        },
        removeSession(state, sessionId) {
            Vue.delete(state.activeConversation, sessionId)
        },
        removeSessions(state, robotId) {
            state.conversations = state.conversations.filter((conv) => conv.aiType !== robotId)
        },
        setPapers(state, papers) {
            state.papers = papers
        },
        addPaper(state, paper) {
            state.papers.push(paper)
        },
        removePaper(state, paperId) {
            let idx = state.papers.findIndex(paper => paper.id === paperId)
            if (idx !== -1) {
                state.papers.splice(idx, 1)
            }
        },
        SET_DEVICE_TYPE(state, isMobile) {
            state.isMobile = isMobile;
        },
        SET_DEVICE_HEIGHT(state, height) {
            state.deviceHeight = height;
        },
        SET_isKeyboardOpen(state, flag) {
            state.isKeyboardOpen = flag
        },
        SET_lastLevelType(state, flag) {
            state.lastLevelType = flag
        },
        setLevel(state, grade) {
            if (!grade) {
                state.level = 'h'
                return
            }
            const isPrimary = [
                '一年级', '二年级', '三年级', '四年级', '五年级', '六年级',
                '小学一年级', '小学二年级', '小学三年级', '小学四年级', '小学五年级', '小学六年级'
            ].some(g => grade.startsWith(g));
            if (isPrimary) {
                state.level = 'p'
                return
            }
            const isMiddle = ['七年级', '八年级', '九年级', '初一', '初二', '初三'].some(g => grade.startsWith(g));
            if ('七年级八年级九年级初一初二初三'.includes(grade) || isMiddle) {
                state.level = 'm'
            } else {
                state.level = 'h'
            }
        },
        ADD_ID(state) {
            state.id++
        },
        ADD_NEWCHAT(state, { robotId, sessionId }) {
            Vue.set(state.messageStorage[robotId], sessionId, {
                cname: '新会话',
                chatList: [],
                isInput: false
            })
        },
        SET_MESSAGESTORAGE(state) {
            for (const key in state.robots) {
                Vue.set(state.messageStorage, key, {})
            }
        },
        INIT_ROBOTSESSIONMAP(state) {
            for (const key in state.robots) {
                Vue.set(state.robotSessionMap, key, state.sessionId)
            }
        },
        SET_ROBOTSESSIONMAP(state, { robotId, sessionId }) {
            state.robotSessionMap[robotId] = sessionId
        },
        SET_FOLDHISTORY(state, status = true) {
            state.foldHistory = status
        },
        SET_FOLDROBOT(state, status = true) {
            state.foldRobot = status
        },
        UPDATE_MESSAGE(state, { robotId, key, msg, type = null }) {
            try {
                if (!msg) return;
                if (!state.messageStorage[robotId]) {
                    Vue.set(state.messageStorage, robotId, {})
                }
                let chat = state.messageStorage[robotId][key]
                if (!chat) {
                    chat = {
                        cname: '新会话',
                        chatList: [],
                        isInput: false,
                    }
                    Vue.set(state.messageStorage[robotId], key, chat);
                }
                let current = chat.chatList.push(msg)
                if ((robotId === 'exercises' || robotId === 'mexercises' || robotId === 'pexercises') && current === 3) {
                    if (type === 'wall') {
                        chat.cname = '##你的知识墙'
                        return
                    }
                    chat.cname = msg.msg || (msg.fileList && msg.fileList[0]?.name) || (msg.parts && msg.parts[0]?.title)
                    if (!chat.cname) chat.cname = '新会话'
                }
                if (robotId === 'composition' && current === 2) {
                    chat.cname = msg.title || msg.msg || (msg.fileList && msg.fileList[0]?.name)
                    if (!chat.cname) chat.cname = '新会话'
                }
            } catch (error) {
                console.log("===========error==============", error)
            }
        },
        UPDATE_NAME(state, { key, name }) {
            Vue.set(state.messageStorage[state.robotId][key], "cname", name)
        },

        setConversations(state, conversations) {
            state.conversations = conversations;
        },
        addConversation(state, conversation) {
            state.conversations.push(conversation);
        },
        // 原有的异步 mutation，保持不动，供其他地方使用
        async updateConversation(state, updatedConversation) {
            const index = state.conversations.findIndex(
                conv => conv.id === updatedConversation.id
            );
            if (index !== -1) {
                state.conversations.splice(index, 1, updatedConversation);
            }
            await IndexedDBService.saveConversation(updatedConversation);
        },
        deleteConversation(state, ids) {
            const idsToDelete = Array.isArray(ids) ? ids : [ids];
            state.conversations = state.conversations.filter(conv => idsToDelete.includes(conv.id) === false);
            if (state.activeConversation && idsToDelete.includes(state.activeConversation.id)) {
                state.activeConversation = null;
            }
        },
        setActiveConversation(state, conversation) {
            state.activeConversation = conversation;
        },
        clearAllConversations(state) {
            state.conversations = [];
            state.activeConversation = null;
        },
        setDbInitialized(state, status) {
            state.dbInitialized = status;
        },

        // 新增：纯同步的状态替换，不操作数据库，避免重复写入
        SYNC_UPDATE_CONVERSATION(state, updatedConversation) {
            const index = state.conversations.findIndex(
                conv => conv.id === updatedConversation.id
            );
            if (index !== -1) {
                state.conversations.splice(index, 1, updatedConversation);
            }
        },

        CLEAR_MESSAGE(state) {
            state.messageStorage = {}
            state.papers = {}
            authApi.removeZsToken()
        },
        setTheme(state, theme) {
            state.theme = theme
            localStorage.setItem("air-conditioner-theme", theme)
            document.head
                .querySelector("#theme-link")?.setAttribute("href", `./styles/theme-${theme}.css`)
        },
        getTheme(state) {
            state.theme = localStorage.getItem("air-conditioner-theme") || "light"
            document.head
                .querySelector("#theme-link")?.setAttribute("href", `./styles/theme-${state.theme}.css`)
        }
    },
    actions: {
        async initDB({ commit, dispatch }) {
            try {
                await IndexedDBService.init();
                commit('setDbInitialized', true);
                await dispatch('loadAllConversations');
                return true;
            } catch (error) {
                console.error('数据库初始化失败:', error);
                return false;
            }
        },
        async loadAllConversations({ commit }) {
            try {
                const conversations = await IndexedDBService.getAllConversations();
                commit('setConversations', conversations);
                return conversations;
            } catch (error) {
                console.error('加载所有对话失败:', error);
                return [];
            }
        },
        async loadConversationsByAiType(_, aiType) {
            try {
                return await IndexedDBService.getConversationsByAiType(aiType);
            } catch (error) {
                console.error(`加载${aiType}类型对话失败:`, error);
                return [];
            }
        },
        async createConversation({ commit }, { aiType, id, name }) {
            try {
                const newConversation = {
                    aiType,
                    id,
                    messages: [],
                    name,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                };
                // 深拷贝后保存，确保可结构化克隆
                await IndexedDBService.saveConversation(JSON.parse(JSON.stringify(newConversation)));
                commit('addConversation', newConversation);
                commit('setActiveConversation', newConversation);
                commit('SET_ROBOTSESSIONMAP', { robotId: aiType, sessionId: id });
                return newConversation;
            } catch (error) {
                console.error('创建新对话失败:', error);
                return null;
            }
        },

        // 优化后的添加消息，消除重复数据库写入，移除不必要深拷贝
        async addMessageToConversation({ commit, state }, { message, type }) {
            try {
                const conversation = await IndexedDBService.getConversationById(message.sessionId);
                if (!conversation) {
                    throw new Error(`ID为${message.sessionId}的对话不存在`);
                }

                let currIdx = 0;
                let currConv = [];
                state.conversations.forEach((conv, index) => {
                    if (conv.id === message.sessionId) {
                        currConv = conv;
                        currIdx = index;
                    }
                });

                if (!conversation.messages) {
                    conversation.messages = [];
                    conversation.name = "新会话";
                }
                if (!currConv.messages) {
                    currConv.messages = [];
                }

                message.timestamp = new Date().toISOString();
                // 直接使用原对象，IndexedDB 会结构化克隆
                conversation.messages.push(message);
                let current = currConv.messages.push(message);
                Vue.set(state.conversations, currIdx, currConv);

                conversation.updatedAt = new Date().toISOString();

                // 命名逻辑（完全保留原行为）
                if (conversation.name === '新会话') {
                    let robotId = message.robotId;
                    if ((robotId === 'exercises' || robotId === 'mexercises' || robotId === 'pexercises') && current === 3) {
                        if (type === 'wall') {
                            conversation.name = '你的知识墙';
                            // 注意：不再 return，继续保存
                        } else {
                            let name = message.msg || (message.fileList && message.fileList[0]?.name) || (message.parts && message.parts[0]?.title);
                            if (name) conversation.name = name;
                        }
                    }
                    if (robotId === 'composition' && current === 2) {
                        let name = message.title || message.msg || (message.fileList && message.fileList[0]?.name);
                        if (name) conversation.name = name;
                    }
                }

                currConv.name = conversation.name;

                // 关键修复：深拷贝后保存，避免不可克隆对象导致写入失败
                await IndexedDBService.saveConversation(JSON.parse(JSON.stringify(conversation)));

                // 同步 state（替换原 commit('updateConversation', currConv)，避免二次存库）
                commit('SYNC_UPDATE_CONVERSATION', currConv);

                return currConv;
            } catch (error) {
                console.error('添加消息到对话失败:', error, message.sessionId);
                return null;
            }
        },

        // 优化后的流式更新，移除不必要深拷贝
        async updateMessageToConversation({ commit, state }, { message, type }) {
            try {
                const conversation = await IndexedDBService.getConversationById(message.sessionId);
                if (!conversation) {
                    throw new Error(`ID为${message.sessionId}的对话不存在`);
                }

                if (!conversation.messages) {
                    conversation.messages = [];
                }

                // 从后向前查找并替换（不再手动深拷贝）
                for (let i = conversation.messages.length - 1; i >= 0; i--) {
                    if (conversation.messages[i].id === message.id) {
                        conversation.messages.splice(i, 1, message);
                        if (i === 2 && conversation.name === 'loading') {
                            let parts = message.parts;
                            let newName = parts && parts[0] && parts[0].title;
                            if (newName) {
                                conversation.name = newName;
                            }
                        }
                        break;
                    }
                }

                conversation.updatedAt = new Date().toISOString();
                // 深拷贝后保存
                await IndexedDBService.saveConversation(JSON.parse(JSON.stringify(conversation)));

                // 同步 state（更新对应对话的名称和消息）
                let currConv = state.conversations.find(conv => conv.id === message.sessionId);
                if (currConv) {
                    const msgIndex = currConv.messages.findIndex(m => m.id === message.id);
                    if (msgIndex !== -1) {
                        currConv.messages.splice(msgIndex, 1, message);
                    }
                    if (conversation.name !== currConv.name) {
                        currConv.name = conversation.name;
                    }
                }

                return conversation;
            } catch (error) {
                console.error('更新消息到对话失败:', error, message.sessionId);
                return null;
            }
        },

        // 更新对话名称
        async updateConversationName({ commit }, { conversationId, newName }) {
            try {
                const conversation = await IndexedDBService.getConversationById(conversationId);
                if (!conversation) {
                    throw new Error(`ID为${conversationId}的对话不存在`);
                }
                conversation.name = newName;
                conversation.updatedAt = new Date().toISOString();
                // 深拷贝后保存
                await IndexedDBService.saveConversation(JSON.parse(JSON.stringify(conversation)));
                return conversation;
            } catch (error) {
                console.error('更新对话名称失败:', error);
                return null;
            }
        },
        async deleteConversation({ commit }, conversationId) {
            try {
                await IndexedDBService.deleteConversations(conversationId);
                commit('deleteConversation', conversationId);
                return true;
            } catch (error) {
                console.error('删除对话失败:', error);
                return false;
            }
        },
        async switchActiveConversation({ commit }, conversationId) {
            try {
                const conversation = await IndexedDBService.getConversationById(conversationId);
                if (conversation) {
                    commit('setActiveConversation', conversation);
                    return conversation;
                }
                return null;
            } catch (error) {
                console.error('切换活跃对话失败:', error);
                return null;
            }
        },
        async clearAllConversations({ commit }) {
            try {
                await IndexedDBService.clearAllConversations();
                commit('clearAllConversations');
                return true;
            } catch (error) {
                console.error('清空所有对话失败:', error);
                return false;
            }
        }
    },
    getters: {
        allConversations: state => state.conversations,
        activeConversation: state => state.activeConversation,
        conversationsByAiType: (state) => (aiType) => {
            return state.conversations
              .filter(conv => conv.aiType === aiType)
              .sort((a, b) => {
                const timeA = new Date(a.updatedAt || a.createdAt).getTime();
                const timeB = new Date(b.updatedAt || b.createdAt).getTime();
                return timeB - timeA;
              });
        },
        isDbInitialized: state => state.dbInitialized
    }
})